// Contains a crash in one of a module's chrome slots (HeaderNavExtras, HeaderActions,
// BelowHeader). Those render OUTSIDE ModuleBoundary, around the page rather than in it,
// so without this a throw in Support's DraftTabs took the header and the page with it.
// A broken slot disappears instead: the person keeps the header, the dropdown and the
// page, and the console says which slot and why.
import { Component } from 'react';

export default class SlotBoundary extends Component {
  constructor(props) { super(props); this.state = { failed: false }; }
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { console.error(`[shell] the ${this.props.name} slot crashed and is hidden`, error); }
  render() { return this.state.failed ? null : this.props.children; }
}
